/**
 * 23/12 既存のBusinessDataManageが扱うインターフェースを変更したので、段階的に移行する（このファイルは新バージョン）
 *
 * このファイルの目的
 * 組織が保持する全ての取引情報について、DBへのアクセスを隠蔽して、UIロジック層が使いやすい形で保持・提供する
 *
 *
 * やるべきこと
 * UIロジックに対して、取引オブジェクトの一覧を返したり、指定された取引オブジェクトを返したり、書き込み（更新）要求を受け付けてDBに登録する機能を提供する
 * DB(cacheManage)からorganizationTableのデータを取得して、取引情報だけを分離して、一つ一つの取引をオブジェクトにする
 * 個別の取引オブジェクトが更新するときに、必要最小限のDBレコードを更新登録する
 */

import { split } from '@/businessRepository/organizationTable/splitter';
import { createArrivalId, createBusinessId } from '@/businessRepository/idUtils';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { IArrival } from '@/coreDomainsModule/entities/arrival';
import { OrganizationDataManage } from '@/businessRepository/organizationTable/organizationDataManage';
import { IOrganizationRecordHeader } from '@/coreDomainsModule/entities/record';

type ReturnSplitType = ReturnType<typeof split>;

/**
 *
 */
class newBusinessDataManage<T> extends OrganizationDataManage<T> {
  /**
   *
   * @param idName
   * @param arranger
   */
  constructor(idName: string, arranger?: (ent: T) => (T | IOrganizationRecordHeader)[] | (T | IOrganizationRecordHeader)) {
    super(idName, arranger);
  }

  /**
   * 同一グループ内の取引オブジェクト群を返す
   * @param business
   */
  public getBusinessesInGroup = (business: T): T[] => {
    if (!(business as any).group || (business as any).group.length === 0) return [];
    const res: T[] = [];
    (business as any).group.forEach((p) => {
      res.push(this.allEntries[p] as any);
    });
    return res;
  };
}

/**
 * 値が完全に入力されていないarrivalsは保存しない
 * @param form
 */
const _sanitizeArrival = (form: IBusiness) => {
  const copyArrival = Object.assign([], form.arrivals);
  form.arrivals = copyArrival.filter((a: IArrival) => a.year !== 0);
};

/**
 * 商品情報をDBに保存するためのレコード情報に分割する。organizationIdやbusinessIdはここで自動付与する
 * @param entry
 */
const _prepareBusiness = (entry: IBusiness): any[] => {
  if (!entry.businessId) entry.businessId = createBusinessId(); // businessIdが設定されていない情報の場合は新規登録になるので新しいbusinessIdを生成する
  // TODO: 仕様が固まっていないので仮設置、一旦businessIdのように実装してみる
  entry.recommend.forEach((ent) => {
    if (!ent.arrivalId) ent.arrivalId = createArrivalId();
  });
  if (!entry.organizationId) entry.organizationId = '';
  if (!entry.dataId) entry.dataId = `${entry.businessId}_base`;
  _sanitizeArrival(entry);
  const { dataType, ...rest } = entry;
  return [{ dataType: 'business', ...rest }];

  // TODO: 1レコード=1オブジェクトの前提になっているが、あとでsplitter/aggregatorを実装する
  // const { base, forecast, inventory, arrivals, salesResults, item } = split(entry);
  // console.log('>>>base:', base);
  // console.log('>>>forecast:', forecast);
  // console.log('>>>inventory:', inventory);
  // const toRegister: ReturnSplitType[keyof Omit<ReturnSplitType, 'bom'>][] = [];
  // TODO: 更新が必要な情報だけを返す(今は全部登録することになっている）
  // if (base) toRegister.push(base);
  // if (forecast) toRegister.push(forecast);
  // if (inventory) toRegister.push(inventory);
  // if (arrivals) toRegister.push(arrivals);
  // if (salesResults) toRegister.push(salesResults);
  // if (item) toRegister.push(item);
  // return toRegister;
};

let businessManager: newBusinessDataManage<IBusiness>;

/**
 *
 */
const getBusinessManager = () => {
  if (!businessManager) businessManager = new newBusinessDataManage<IBusiness>('businessId', _prepareBusiness);
  return businessManager;
};

export { getBusinessManager, newBusinessDataManage };
